export default __webpack_public_path__ + "static/media/dish1.c08f9b6a.jpg";